<template>
  <svg
    fill="currentColor"
    width="800px"
    height="800px"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M40,47H8a2,2,0,0,1-2-2V3A2,2,0,0,1,8,1H40a2,2,0,0,1,2,2V45A2,2,0,0,1,40,47ZM10,43H38V5H10Z" />
    <path d="M14,19a2,2,0,0,1-2-2V9a2,2,0,0,1,2-2h8a2,2,0,0,1,0,4H16v6A2,2,0,0,1,14,19Z" />
    <path d="M34,41H26a2,2,0,0,1,0-4h6V31a2,2,0,0,1,4,0v8A2,2,0,0,1,34,41Z" />
  </svg>
</template>
